export default "__VITE_ASSET__DRUQe8Iq__"